import styles from './Tab.module.scss';
import AvatarWithMarketplace from '@components/AvatarWithMarketplace';
import BeforeAwaitingTable from '../components/BeforeAwaitingTable/BeforeAwaitingTable';
import Box from '@components/Box';
import CardParcelModalWindow from '../modals/CardParcelModalWindow/CardParcelModalWindow';
import cn from 'classnames';
import DataTable, { BeforeProps, DataViewHandle } from '@containers/DataTable';
import DisposalProcessingModalWindow from '../modals/DisposalProcessingModalWindow';
// import DocumentLink from '@components/DocumentLink';
import PaymentCompletedModalWindow from '@components/modals/PaymentCompletedModalWindow';
import PaymentModalWindow from '@components/modals/PaymentModalWindow';
import PlacingOrderModalWindow from '@components/modals/PlacingOrderModalWindow';
import ProgressBar from '@components/ProgressBar';
import ResaleProcessingModalWindow from '../modals/ResaleProcessingModalWindow';
import ReturnCostModalWindow from '../modals/ReturnCostModalWindow/ReturnCostModalWindow';
import TableSelectionPanel from '@components/Table/TableSelectionPanel';
import TrackingNumber from "@components/TrackingNumber";
import { toast } from 'react-toastify';
import TruckIcon from '@assets/icons/truck-grey-12.svg';
import UIcon from '@assets/icons/u-blue-10.svg';
import WarningIcon from '@assets/icons/warning-red-12.svg';
import AlertIcon from "@assets/icons/solid/circle-alert.svg?react";
// import YuanIcon from '@assets/icons/yuan-blue-18.svg';
import { actionAddresses } from '@utils/handlerSubmitActions';
import { AddSellerPanel } from '@components/AddSeller';
import { Badge, BadgeType } from '@components/new/Badge';
import { Button, ButtonSize, ButtonType } from '@components/Button';
import {
  checkBalanceReplenishment,
  checkBalanceReplenishmentResponse,
  getPaymentLink,
  getWallet,
  sendTopUpBalance,
  sendTopUpBalanceResponse,
  TGetPaymentLinkResponse
} from '@api/apiClient/finance';
import {
  checkDeliverToLocalOrderStatus,
  checkLastMileResaleOrderStatus,
  checkReexportOrderStatus,
  checkResaleOrderStatus,
  getAwaiting,
  getLastMileWarehouses,
  ONLY_AVAILABLE_FOR_RESALE_FILTER,
  sendDeliverToLocalOrder,
  sendLastMileResaleOrder,
  sendResaleOrder,
  sendReturnOrder,
  TAwaitingParcel,
  TCheckOrderStatusResponse,
  TDeliverToLocalOrderParams,
  TDeliverToLocalOrderResponse,
  TLastMileResaleOrderParams,
  TResaleOrderParams,
  TResaleOrderResponse,
  TReturnOrderAddress,
  TReturnOrderParams,
  TReturnOrderResponse
} from '@api/apiClient/returns';
import { Column, Row } from '@components/Grid';
import {
  EPlacingOrder,
  TPlacingOrderData,
  TPlacingOrderDataItem
} from '@components/modals/PlacingOrderModalWindow/types';
import {
  EPlacingOrderViewParcel,
  EPlacingOrderViewParcelType,
  getPlacingOrderView
} from '@utils/createPlacingOrderView';
import { FilterModel } from '@hooks/useFiltersSearchParams';
import { Filters, FilterTypes } from '@containers/Filters';
import { formatSumFromObject, formatSumWithCurrency } from '@utils/formatValues';
import { getCurrentLanguage } from '@utils/lang';
import { getDaysBetweenDates } from '@utils/progress';
import { IAwaitingTabProps } from '../types';
import { Modal } from '@components/Modal';
import { sortByPrice, sortByStores } from '@utils/sorting';
import { TableColumn, TableColumnType, TableRowType } from '@components/Table/TableTypes.ts';
import { Text, TextColor, TextSize, TextType } from '@components/Text';
import { Tooltip } from '@components/new/Tooltip';
import { TPlacingOrderListItem } from '@components/PlacingOrderView/types';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { useProfile } from '@contexts/ProfileContext';
import { useTranslation } from 'react-i18next';

const AwaitingTab: React.FC<IAwaitingTabProps> = (props: IAwaitingTabProps): React.ReactElement => {
  const {
    isFilterOpen,
    onlyAvailableForResale,
    onUpdateAwaiting,
    onUpdateDisposal,
    onUpdateLastMileResale,
    onUpdateResale,
    onUpdateReturns,
    sellersNotFound,
    setIsFilterOpen
  } = props;

  const [columnsSort, setColumnsSort] = useState<string[]>([]);
  const [innerFilters, setInnerFilters] = useState<FilterModel[]>([]);
  const tableFilters = useMemo<FilterModel[]>(() => [
    ...innerFilters.filter((filter: FilterModel) => filter.name !== ONLY_AVAILABLE_FOR_RESALE_FILTER),
    ...(onlyAvailableForResale
      ? [{ name: ONLY_AVAILABLE_FOR_RESALE_FILTER, value: ['true'] }]
      : [])
  ], [innerFilters, onlyAvailableForResale]);
  const [isInitialized, setIsInitialized] = useState<boolean>(false);
  const [isOpenDeliverToLocalProcessingWindow, setIsOpenDeliverToLocalProcessingWindow] = useState<boolean>(false);
  const [isOpenDisposalProcessingWindow, setIsOpenDisposalProcessingWindow] = useState<boolean>(false);
  const [isOpenLastMileProcessingWindow, setIsOpenLastMileProcessingWindow] = useState<boolean>(false);
  const [isOpenParcelWindow, setIsOpenParcelWindow] = useState(false);
  const [isOpenPaymentCompletedWindow, setIsOpenPaymentCompletedWindow] = useState<boolean>(false);
  const [isOpenPaymentWindow, setIsOpenPaymentWindow] = useState<boolean>(false);
  const [isOpenResaleProcessingWindow, setIsOpenResaleProcessingWindow] = useState<boolean>(false);
  const [isOpenReturnCostWindow, setIsOpenReturnCostWindow] = useState(false);
  const [isOpenReturnProcessingWindow, setIsOpenReturnProcessingWindow] = useState<boolean>(false);
  const [orderInProcessed, setOrderInProcessed] = useState<boolean>(false);
  const [parcel, setParcel] = useState<TAwaitingParcel | undefined>(undefined);
  const [parcelsAnyLastMileView, setParcelsAnyLastMileView] = useState<TPlacingOrderListItem[] | undefined>(undefined);
  const [parcelsAnyResaleView, setParcelsAnyResaleView] = useState<TPlacingOrderListItem[] | undefined>(undefined);
  const [parcelsAnyReturnView, setParcelsAnyReturnView] = useState<TPlacingOrderListItem[] | undefined>(undefined);
  const [parcelsGoodDisposalView, setParcelsGoodDisposalView] = useState<TPlacingOrderListItem[] | undefined>(undefined);
  const [parcelsGoodLastMileView, setParcelsGoodLastMileView] = useState<TPlacingOrderListItem[] | undefined>(undefined);
  const [parcelsGoodResaleView, setParcelsGoodResaleView] = useState<TPlacingOrderListItem[] | undefined>(undefined);
  const [parcelsGoodDeliverToLocalView, setParcelsGoodDeliverToLocalView] = useState<TPlacingOrderListItem[] | undefined>(undefined);
  const [parcelsGoodReturnView, setParcelsGoodReturnView] = useState<TPlacingOrderListItem[] | undefined>(undefined);
  const [parcelView, setParcelView] = useState<TPlacingOrderListItem[] | undefined>(undefined);
  const [paymentError, setPaymentError] = useState<string | undefined>(undefined);
  const [paymentInProcessed, setPaymentInProcessed] = useState<boolean>(false);
  const [processingCalledFrom, setProcessingCalledFrom] = useState<string>('');
  const [processingPaymentType, setProcessingPaymentType] = useState<string>('');
  const [selectedDeliverToLocalCost, setSelectedDeliverToLocalCost] = useState<number>(0);
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const [selectedLastMileResaleCost, setSelectedLastMileResaleCost] = useState<number>(0);
  const [selectedLastMileSumCny, setSelectedLastMileSumCny] = useState<number>(0);
  const [selectedLastMileSumRub, setSelectedLastMileSumRub] = useState<number>(0);
  const [selectedParcels, setSelectedParcels] = useState<Map<string, TAwaitingParcel>>(new Map());
  const [selectedResaleCost, setSelectedResaleCost] = useState<number>(0);
  const [selectedResaleSumCny, setSelectedResaleSumCny] = useState<number>(0);
  const [selectedResaleSumRub, setSelectedResaleSumRub] = useState<number>(0);
  const [selectedReturnCost, setSelectedReturnCost] = useState<number>(0);
  const [selectedDisposalCompensation, setSelectedDisposalCompensation] = useState<number>(0);
  const [selectedSumCny, setSelectedSumCny] = useState<number>(0);
  const [selectedSumRub, setSelectedSumRub] = useState<number>(0);
  const [submitLastMileParams, setSubmitLastMileParams] = useState<TLastMileResaleOrderParams | undefined>(undefined);
  const [submitDeliverToLocalParams, setSubmitDeliverToLocalParams] = useState<TDeliverToLocalOrderParams | undefined>(undefined);
  const [submitResaleParams, setSubmitResaleParams] = useState<TResaleOrderParams | undefined>(undefined);
  const [submitReturnParams, setSubmitReturnParams] = useState<TReturnOrderParams | undefined>(undefined);

  const dataRef = useRef<DataViewHandle>(null);
  const timeoutCheckBalance = useRef<number | null>(null);
  const timeoutCheckPayment = useRef<number | null>(null);
  const timeoutCheckStatus = useRef<number | null>(null);

  const currentLanguage = getCurrentLanguage();
  const { account, get } = useProfile();
  const { t } = useTranslation();
  const hasSelectedResaleBlocked = Array.from(selectedParcels.values())
      .some((item: TAwaitingParcel) => item.isResaleBlocked);
  const isLastMileResaleFeatureEnabled = Boolean(
      account?.isTestUser && account.features.customerReturnsResales
  );
  const { data: lastMileWarehousesData } = useQuery({
    queryKey: ['lastMileWarehouses'],
    queryFn: getLastMileWarehouses,
    retry: 1,
    enabled: isLastMileResaleFeatureEnabled && !sellersNotFound
  });
  const hasLastMileWarehouse = Boolean(lastMileWarehousesData?.warehouses.length);

  const variableCurrency: string = account?.region === 'TR' ? '$' : '¥';

  const handleSelectionChange = useCallback((
      selectedIds: string[],
      items: TAwaitingParcel[]
  ) => {
    setSelectedIds(selectedIds);

    const parcels: Map<string, TAwaitingParcel> = new Map();

    selectedParcels.forEach((parcel: TAwaitingParcel, key: string) => {
      const item = items.find((v: TAwaitingParcel) => v.id === key);
      if (!item) parcels.set(key, parcel);
    });

    selectedIds.forEach((id) => {
      const item = items.find((v: TAwaitingParcel) => (v.id === id));
      if (item) {
        parcels.set(id, item);
      } else {
        const selectedItem = selectedParcels.get(id);
        if (selectedItem) {
          parcels.set(id, selectedItem);
        }
      }
    });

    const parcelsArray: TAwaitingParcel[] = Array.from(parcels.values());
    const parcelsGoodReturn: TAwaitingParcel[] = parcelsArray.filter((item: TAwaitingParcel) => !item.reexportCancelReason);
    const parcelsGoodResale: TAwaitingParcel[] = parcelsArray.filter((item: TAwaitingParcel) => !item.resaleCancelReason);
    const parcelsGoodLastMile: TAwaitingParcel[] = parcelsArray.filter(
        (item: TAwaitingParcel) => item.isAvailableForLastMileResale && !item.isResaleBlocked
    );

    const lastMileResaleCost = +parcelsGoodLastMile.reduce((acc, v) => (acc + (v.lastMileResalePrice?.amount ?? 0)), 0).toFixed(2);
    const lastMileSumCny = +parcelsGoodLastMile.reduce((acc, v) => (acc + v.priceCny), 0).toFixed(2);
    const lastMileSumRub = +parcelsGoodLastMile.reduce((acc, v) => (acc + v.priceRub), 0).toFixed(2);
    const parcelsGoodDeliverToLocal: TAwaitingParcel[] = parcelsArray.filter((item: TAwaitingParcel) => item.deliverToLocalPrice);

    const deliverToLocalCost = +parcelsGoodDeliverToLocal.reduce((acc, v) => (acc + (v.deliverToLocalPrice?.amount ?? 0)), 0).toFixed(2);
    const resaleCost = +parcelsGoodResale.reduce((acc, v) => (acc + v.resalePrice.amount), 0).toFixed(2);
    const resaleSumCny = +parcelsGoodResale.reduce((acc, v) => (acc + v.priceCny), 0).toFixed(2);
    const resaleSumRub = +parcelsGoodResale.reduce((acc, v) => (acc + v.priceRub), 0).toFixed(2);
    const returnCost = +parcelsGoodReturn.reduce((acc, v) => (acc + v.reexportPrice.amount), 0).toFixed(2);
    const disposalCompensation = +parcelsArray.reduce((acc, v) => (acc + (v.utilizationCompensation?.amount ?? 0)), 0).toFixed(2);
    const sumCny = +parcelsArray.reduce((acc, v) => (acc + v.priceCny), 0).toFixed(2);
    const sumRub = +parcelsArray.reduce((acc, v) => (acc + v.priceRub), 0).toFixed(2);

    setSelectedDeliverToLocalCost(deliverToLocalCost);
    setSelectedParcels(parcels);
    setSelectedLastMileResaleCost(lastMileResaleCost);
    setSelectedLastMileSumCny(lastMileSumCny);
    setSelectedLastMileSumRub(lastMileSumRub);
    setSelectedResaleCost(resaleCost);
    setSelectedResaleSumCny(resaleSumCny);
    setSelectedResaleSumRub(resaleSumRub);
    setSelectedReturnCost(returnCost);
    setSelectedDisposalCompensation(disposalCompensation);
    setSelectedSumCny(sumCny);
    setSelectedSumRub(sumRub);
  }, [selectedParcels]);

  useEffect(() => {
    const parcelsArray: TAwaitingParcel[] = Array.from(selectedParcels.values());
    const parcelsAnyReturn: TAwaitingParcel[] = parcelsArray.filter((item: TAwaitingParcel) => item.reexportCancelReason);
    const parcelsAnyResale: TAwaitingParcel[] = parcelsArray.filter((item: TAwaitingParcel) => item.resaleCancelReason);
    const parcelsAnyLastMile: TAwaitingParcel[] = parcelsArray.filter((item: TAwaitingParcel) => item.isResaleBlocked);
    const parcelsGoodReturn: TAwaitingParcel[] = parcelsArray.filter((item: TAwaitingParcel) => !item.reexportCancelReason);
    const parcelsGoodResale: TAwaitingParcel[] = parcelsArray.filter((item: TAwaitingParcel) => !item.resaleCancelReason);
    const parcelsGoodLastMile: TAwaitingParcel[] = parcelsArray.filter(
        (item: TAwaitingParcel) => item.isAvailableForLastMileResale && !item.isResaleBlocked
    );

    const parcelsAnyReturnView: TPlacingOrderListItem[] =
        getPlacingOrderView(parcelsAnyReturn, EPlacingOrderViewParcel.RETURN_AWAITING_RETURN, {
          t,
          type: EPlacingOrderViewParcelType.ANY
        });

    const parcelsAnyResaleView: TPlacingOrderListItem[] =
        getPlacingOrderView(parcelsAnyResale, EPlacingOrderViewParcel.RETURN_AWAITING_RESALE, {
          actionTooltipNoEan: <>
            <a
                href="https://docs.ozon.ru/global/zh-hans/products/upload/barcode-upload/?country=CN&__rr=1&abt_att=1&origin_referer=dev.azure.com"
                rel="noreferrer"
                target="_blank"
            >{t(`resaleOrder.tooltip.NoEan_1`)}</a> {t(`resaleOrder.tooltip.NoEan_2`)}
          </>,
          t,
          type: EPlacingOrderViewParcelType.ANY
        });

    const parcelsAnyLastMileView: TPlacingOrderListItem[] =
        getPlacingOrderView(parcelsAnyLastMile, EPlacingOrderViewParcel.RETURN_AWAITING_RESALE, {
          t,
          type: EPlacingOrderViewParcelType.ANY,
          useResaleBlockReason: true,
          variableCurrency
        });

    const parcelsGoodDisposalView: TPlacingOrderListItem[] =
        getPlacingOrderView(parcelsArray, EPlacingOrderViewParcel.RETURN_AWAITING_RETURN, {
          type: EPlacingOrderViewParcelType.GOOD,
          variableCurrency
        });

    const parcelsGoodDeliverToLocal: TAwaitingParcel[] = parcelsArray.filter((item: TAwaitingParcel) => item.deliverToLocalPrice);

    const parcelsGoodDeliverToLocalView: TPlacingOrderListItem[] =
        getPlacingOrderView(parcelsGoodDeliverToLocal, EPlacingOrderViewParcel.RETURN_AWAITING_RETURN, {
          type: EPlacingOrderViewParcelType.GOOD,
          variableCurrency
        });

    const parcelsGoodReturnView: TPlacingOrderListItem[] =
        getPlacingOrderView(parcelsGoodReturn, EPlacingOrderViewParcel.RETURN_AWAITING_RETURN, {
          type: EPlacingOrderViewParcelType.GOOD,
          variableCurrency
        });

    const parcelsGoodResaleView: TPlacingOrderListItem[] =
        getPlacingOrderView(parcelsGoodResale, EPlacingOrderViewParcel.RETURN_AWAITING_RESALE, {
          type: EPlacingOrderViewParcelType.GOOD,
          variableCurrency
        });

    const parcelsGoodLastMileView: TPlacingOrderListItem[] =
        getPlacingOrderView(parcelsGoodLastMile, EPlacingOrderViewParcel.RETURN_AWAITING_RESALE, {
          type: EPlacingOrderViewParcelType.GOOD,
          variableCurrency
        });

    setParcelsAnyLastMileView(parcelsAnyLastMileView.length ? parcelsAnyLastMileView : undefined);
    setParcelsAnyResaleView(parcelsAnyResaleView.length ? parcelsAnyResaleView : undefined);
    setParcelsAnyReturnView(parcelsAnyReturnView.length ? parcelsAnyReturnView : undefined);
    setParcelsGoodDeliverToLocalView(parcelsGoodDeliverToLocalView);
    setParcelsGoodDisposalView(parcelsGoodDisposalView);
    setParcelsGoodLastMileView(parcelsGoodLastMileView);
    setParcelsGoodResaleView(parcelsGoodResaleView);
    setParcelsGoodReturnView(parcelsGoodReturnView);
  }, [currentLanguage, selectedParcels]);

  const onUpdateData = () => {
    if (dataRef.current?.refresh) {
      dataRef.current.refresh();
    }
    onUpdateAwaiting();
    onUpdateDisposal();
    onUpdateLastMileResale();
    onUpdateResale();
    onUpdateReturns();
    setSelectedParcels(new Map());
    setSelectedIds([]);
  };

  const { mutate: mutateCheckBalanceReplenishment } = useMutation({
    mutationFn: checkBalanceReplenishment
  });

  const { mutate: mutateCheckBalance } = useMutation({
    mutationFn: getWallet,
    onSuccess: (result) => {
      const condition: boolean = processingCalledFrom === 'card';
      if (processingPaymentType === 'return') {
        if (result.balance >= (condition ? parcel!.reexportPrice.amount : selectedReturnCost)) {
          mutateSendReturnOrder(submitReturnParams!);
        } else {
          waitingBalanceReplenished();
        }
      } else if (processingPaymentType === 'lastMile') {
        if (result.balance >= selectedLastMileResaleCost) {
          mutateSendLastMileResaleOrder(submitLastMileParams!);
        } else {
          waitingBalanceReplenished();
        }
      } else if (processingPaymentType === 'deliverToLocal') {
        if (result.balance >= (condition ? parcel!.deliverToLocalPrice!.amount : selectedDeliverToLocalCost)) {
          mutateSendDeliverToLocalOrder(submitDeliverToLocalParams!);
        } else {
          waitingBalanceReplenished();
        }
      } else {
        if (result.balance >= (condition ? parcel!.resalePrice.amount : selectedResaleCost)) {
          mutateSendResaleOrder(submitResaleParams!);
        } else {
          waitingBalanceReplenished();
        }
      }
    }
  });

  const { mutate: mutateCheckReturnOrderStatus } = useMutation({
    mutationFn: checkReexportOrderStatus
  });

  const { mutate: mutateCheckResaleOrderStatus } = useMutation({
    mutationFn: checkResaleOrderStatus
  });

  const { mutate: mutateCheckLastMileResaleOrderStatus } = useMutation({
    mutationFn: checkLastMileResaleOrderStatus
  });

  const { mutate: mutateCheckDeliverToLocalOrderStatus } = useMutation({
    mutationFn: checkDeliverToLocalOrderStatus
  });

  const {
    data: dataSendTopUpBalance,
    error: errorSendTopUpBalance,
    isError: isErrorSendTopUpBalance,
    isLoading: isLoadingSendTopUpBalance,
    mutate: mutateSendTopUpBalance,
    reset: resetSendTopUpBalance
  } = useMutation({
    mutationFn: sendTopUpBalance,
    onSuccess: (result: sendTopUpBalanceResponse) => {
      setIsOpenPaymentWindow(true);
      setIsOpenDeliverToLocalProcessingWindow(false);
      setIsOpenResaleProcessingWindow(false);
      setIsOpenReturnProcessingWindow(false);
      setPaymentTimeout();
      waitingBalanceReplenished(result.outTradeNo);
    }
  });

  const {
    error: errorGetPaymentLink,
    isError: isErrorGetPaymentLink,
    isLoading: isLoadingGetPaymentLink,
    mutate: mutateGetPaymentLink
  } = useMutation({
    mutationFn: getPaymentLink,
    onSuccess: (result: TGetPaymentLinkResponse) => {
      setPaymentInProcessed(true);
      setPaymentTimeout();
      waitingBalanceReplenished();
      window.open(result.paymentLink);
    }
  });

  const {
    error: errorSendReturnOrder,
    isError: isErrorSendReturnOrder,
    isLoading: isLoadingSendReturnOrder,
    mutate: mutateSendReturnOrder,
    reset: resetSendReturnOrder
  } = useMutation({
    mutationFn: sendReturnOrder,
    onSuccess: (result: TReturnOrderResponse) => {
      setOrderInProcessed(true);
      waitingOrderStatus(mutateCheckReturnOrderStatus, result.reexportOrderId);
    }
  });

  const {
    error: errorSendResaleOrder,
    isError: isErrorSendResaleOrder,
    isLoading: isLoadingSendResaleOrder,
    mutate: mutateSendResaleOrder,
    reset: resetSendResaleOrder
  } = useMutation({
    mutationFn: sendResaleOrder,
    onSuccess: (result: TResaleOrderResponse) => {
      setOrderInProcessed(true);
      waitingOrderStatus(mutateCheckResaleOrderStatus, result.orderId);
    }
  });

  const {
    error: errorSendLastMileResaleOrder,
    isError: isErrorSendLastMileResaleOrder,
    isLoading: isLoadingSendLastMileResaleOrder,
    mutate: mutateSendLastMileResaleOrder,
    reset: resetSendLastMileResaleOrder
  } = useMutation({
    mutationFn: sendLastMileResaleOrder,
    onSuccess: (result: TResaleOrderResponse) => {
      setOrderInProcessed(true);
      waitingOrderStatus(mutateCheckLastMileResaleOrderStatus, result.orderId);
    }
  });

  const {
    error: errorSendDeliverToLocalOrder,
    isError: isErrorSendDeliverToLocalOrder,
    isLoading: isLoadingSendDeliverToLocalOrder,
    mutate: mutateSendDeliverToLocalOrder,
    reset: resetSendDeliverToLocalOrder
  } = useMutation({
    mutationFn: sendDeliverToLocalOrder,
    onSuccess: (result: TDeliverToLocalOrderResponse) => {
      setOrderInProcessed(true);
      waitingOrderStatus(mutateCheckDeliverToLocalOrderStatus, result.orderId);
    }
  });

  const waitingBalanceReplenished = (id?: string): void => {
    timeoutCheckBalance.current = window.setTimeout(() => {
      if (id) {
        mutateCheckBalanceReplenishment(id, {
          onSuccess: (data: checkBalanceReplenishmentResponse) => {
            if (data.isProcess) {
              if (!paymentInProcessed) setPaymentInProcessed(true);
              waitingBalanceReplenished(id);
            } else {
              if (paymentInProcessed) setPaymentInProcessed(false);
              if (data.isSuccess) {
                clearTimeout(timeoutCheckPayment.current as number);
                mutateCheckBalance();
              } else {
                if (data.errorCode) {
                  clearTimeout(timeoutCheckPayment.current as number);
                  setPaymentError(data.errorCode);
                } else {
                  waitingBalanceReplenished(id);
                }
              }
            }
          }
        });
      } else {
        mutateCheckBalance();
      }
    }, 3000);
  };

  const waitingOrderStatus = (checkOrderStatus: (id: string, p: { onSuccess: (data: TCheckOrderStatusResponse) => void }) => void, id: string): void => {
    timeoutCheckStatus.current = window.setTimeout(() => {
      checkOrderStatus(id, {
        onSuccess: (data: TCheckOrderStatusResponse) => {
          if (data.status === 'New') {
            waitingOrderStatus(checkOrderStatus, id);
          }
          if (data.status === 'Paid') {
            get();
            onCloseLastMileProcessing();
            onCloseDeliverToLocalProcessing();
            onCloseResaleProcessing();
            onCloseReturnProcessing();
            onUpdateData();
            setIsOpenPaymentCompletedWindow(true);
            setIsOpenPaymentWindow(false);
            setOrderInProcessed(false);
            setPaymentInProcessed(false);
          }
          if (data.status === 'Cancelled') {
            onCloseDeliverToLocalProcessing();
            onCloseResaleProcessing();
            onCloseReturnProcessing();
            onUpdateData();
            setIsOpenPaymentWindow(false);
            setOrderInProcessed(false);
            setPaymentInProcessed(false);
            if (processingPaymentType === 'resale') {
              toast.error(t('resaleOrder.cancelledText'));
            }
          }
        }
      });
    }, 3000);
  };

  const setPaymentTimeout = (): void => {
    timeoutCheckPayment.current = window.setTimeout(() => {
      clearTimeout(timeoutCheckBalance.current as number);
      setPaymentInProcessed(false);
    }, 600000);
  };

  const onClosePaymentReturn = (): void => {
    clearTimeout(timeoutCheckBalance.current as number);
    clearTimeout(timeoutCheckPayment.current as number);
    setIsOpenPaymentWindow(false);
    setPaymentInProcessed(false);
  };

  const onClickPaymentLink = (amount: string) => {
    mutateGetPaymentLink(amount);
  };

  const onCloseParcel = () => {
    setIsOpenParcelWindow(false);
  };

  const onCloseDeliverToLocalProcessing = () => {
    resetSendDeliverToLocalOrder();
    resetSendTopUpBalance();
    setIsOpenDeliverToLocalProcessingWindow(false);
    setPaymentInProcessed(false);
  };

  const onCloseDisposalProcessing = () => {
    setIsOpenDisposalProcessingWindow(false);
  };

  const onCloseResaleProcessing = () => {
    resetSendResaleOrder();
    resetSendTopUpBalance();
    setIsOpenResaleProcessingWindow(false);
    setPaymentInProcessed(false);
  };

  const onCloseLastMileProcessing = () => {
    resetSendLastMileResaleOrder();
    resetSendTopUpBalance();
    setIsOpenLastMileProcessingWindow(false);
    setPaymentInProcessed(false);
  };

  const onCloseReturnProcessing = () => {
    resetSendReturnOrder();
    resetSendTopUpBalance();
    setIsOpenReturnProcessingWindow(false);
    setPaymentInProcessed(false);
  };

  const handlerSortByPrice = (position: number, value: string, filters: FilterModel[]): void => {
    sortByPrice({ columnsSort, filters, position, setColumnsSort, setInnerFilters, value });
  };

  const handlerSortByStores = (position: number, value: string, filters: FilterModel[]): void => {
    sortByStores({ columnsSort, filters, position, setColumnsSort, setInnerFilters, value });
  };

  const handlerSubmitReturn = (forms: TPlacingOrderData): void => {
    setProcessingPaymentType('return');
    const condition: boolean = processingCalledFrom === 'card';
    const addresses: TReturnOrderAddress[] = forms.map((item: TPlacingOrderDataItem) => ({
      address: item.address,
      contactInfo: {
        name: item.fullName,
        phone: item.phone
      }
    }));
    const params: TReturnOrderParams = {
      ...addresses[0],
      customerReturnIds: condition
          ? [parcelView![0].id]
          : parcelsGoodReturnView!.map((item: TPlacingOrderListItem) => item.id)
    };
    if (account!.balance >= selectedReturnCost) {
      mutateSendReturnOrder(params);
    } else {
      setSubmitReturnParams(params);
      if (account!.region === 'TR') {
        onCloseReturnProcessing();
        setIsOpenPaymentWindow(true);
      } else {
        mutateSendTopUpBalance({
          amount: (condition ? parcel!.reexportPrice.amount : selectedReturnCost) - account!.balance
        });
      }
    }
    actionAddresses(forms);
  };

  const handlerSubmitDeliverToLocal = (forms: TPlacingOrderData): void => {
    setProcessingPaymentType('deliverToLocal');
    const condition: boolean = processingCalledFrom === 'card';
    const addresses: TReturnOrderAddress[] = forms.map((item: TPlacingOrderDataItem) => ({
      address: item.address,
      contactInfo: {
        name: item.fullName,
        phone: item.phone
      }
    }));
    const cost = condition ? parcel!.deliverToLocalPrice!.amount : selectedDeliverToLocalCost;
    const params: TDeliverToLocalOrderParams = {
      ...addresses[0],
      customerReturnIds: condition
          ? [parcelView![0].id]
          : parcelsGoodDeliverToLocalView!.map((item: TPlacingOrderListItem) => item.id),
      comment: forms[0]?.comment
    };
    if (account!.balance >= cost) {
      mutateSendDeliverToLocalOrder(params);
    } else {
      setSubmitDeliverToLocalParams(params);
      if (account!.region === 'TR') {
        onCloseDeliverToLocalProcessing();
        setIsOpenPaymentWindow(true);
      } else {
        mutateSendTopUpBalance({
          amount: cost - account!.balance
        });
      }
    }
    actionAddresses(forms);
  };

  const handlerSubmitResale = (orderParcelId: string): void => {
    setProcessingPaymentType('resale');
    const params: TResaleOrderParams = {
      resaleSelects: [{
        customerReturnId: parcelView![0].id,
        orderParcelId
      }]
    };
    if (account!.balance >= parcel!.resalePrice.amount) {
      mutateSendResaleOrder(params);
    } else {
      setSubmitResaleParams(params);
      if (account!.region === 'TR') {
        onCloseResaleProcessing();
        setIsOpenPaymentWindow(true);
      } else {
        mutateSendTopUpBalance({
          amount: parcel!.resalePrice.amount - account!.balance
        });
      }
    }
  };

  const handlerSubmitLastMile = (): void => {
    setProcessingPaymentType('lastMile');
    const params: TLastMileResaleOrderParams = {
      customerReturnIds: parcelsGoodLastMileView!.map((item: TPlacingOrderListItem) => item.id)
    };
    if (account!.balance >= selectedLastMileResaleCost) {
      mutateSendLastMileResaleOrder(params);
    } else {
      setSubmitLastMileParams(params);
      if (account!.region === 'TR') {
        onCloseLastMileProcessing();
        setIsOpenPaymentWindow(true);
      } else {
        mutateSendTopUpBalance({
          amount: selectedLastMileResaleCost - account!.balance
        });
      }
    }
  };

  const onClickParcel = (parcel: TAwaitingParcel): void => {
    setIsOpenParcelWindow(true);
    setParcel(parcel);
    setParcelView(getPlacingOrderView([parcel], EPlacingOrderViewParcel.RETURN_AWAITING_RETURN, {
      type: EPlacingOrderViewParcelType.GOOD,
      variableCurrency
    }));
  };

  const BeforeAwaitingTableComponent = useCallback((props: BeforeProps<TAwaitingParcel>) => {
    return (
        <BeforeAwaitingTable {...props} />
    );
  }, []);

  const columns: TableColumn<TAwaitingParcel>[] = useMemo(() => [
    {
      header: t('common.trackingNumber'),
      accessor: (row: TableRowType<TAwaitingParcel>) => (
        <div className={styles.trackNumberContainer}>
          <div className={styles.trackingNumber}>
            {row.data.isResaleBlocked && (
              <Badge type={BadgeType.DESTRUCTIVE}>
                {t('returnsPage.awaitingTab.resaleBlocked')}
              </Badge>
            )}
            <TrackingNumber
              externalId={row.data?.trackingNumber}
              trackNumber={row.data?.directStreamExternalId}
              onClick={() => onClickParcel(row.data)}
              allowEqualNumbers
            />
          </div>
          {row.data.isIncorrectLocalAddress ? (
            <Tooltip
              action={<AlertIcon className={styles.alertIcon} />}
              position="top"
              text={t('returnsPage.awaitingTab.tooltipText_incorrectLocalAddress')}
              whiteSpace="pre-wrap"
              maxWidth={200}
            />
          ) : null}
        </div>
      ),
      fixWidth: true,
      noOverflow: true,
      width: '200px'
    },
    {
      header: t('returnsPage.awaitingTab.name'),
      accessor: (row: TableRowType<TAwaitingParcel>) => (
          <div className={styles.name}>
            <a
                className={styles.link}
                href={row?.data?.url}
                rel="noreferrer"
                target="_blank"
            >
              {row?.data?.title}
            </a>
            {(row.data.productConditionType === 'Defect') && (
                <div className={cn(styles.state, styles.stateInfo)}>
                  <Text
                      color={TextColor.WHITE}
                      size={TextSize.XS}
                  >
                    {t(`returnsPage.awaitingTab.states.${row.data.productConditionType}`)}
                  </Text>
                </div>
            )}
          </div>
      ),
      width: '235px'
    },
    {
      header: t('returnsPage.awaitingTab.priceOfProduct'),
      accessor: (row: TableRowType<TAwaitingParcel>) => {
        const rate = (row.data.priceCny && row.data.priceRub) ? (
            Math.round(100 * row.data.priceRub / row.data.priceCny) / 100
        ) : 0;
        return (
            <div className={styles.price}>
              <Text
                  color={TextColor.PRIMARY}
                  size={TextSize.S}
              >
                {formatSumWithCurrency(row.data.priceRub, '₽')}
              </Text>
              <Tooltip
                  action={
                    <Text
                        color={TextColor.DARK_MUTED}
                        size={TextSize.XS}
                    >
                      {formatSumWithCurrency(row.data.priceCny, variableCurrency)}
                    </Text>
                  }
                  position="left"
                  text={t('returnsPage.awaitingTab.tooltipText_1', { rate })}
                  maxWidth={200}
              />
            </div>
        );
      },
      alignment: 'right',
      noOverflow: true,
      sortable: true,
      sortableFn: handlerSortByPrice,
      width: '120px'
    },
    {
      header: t('returnsPage.awaitingTab.resaleCost'),
      accessor: (row: TableRowType<TAwaitingParcel>) => (
          row.data.availableForResaleOrders?.length ? (
              <div className={styles.actionPrice}>
                {formatSumFromObject(row.data.resalePrice)}
              </div>
          ) : (
              <Text color={TextColor.DARK_MUTED} size={TextSize.XS}>—</Text>
          )
      ),
      noOverflow: true,
      type: TableColumnType.PRIMARY,
      width: '100px'
    },
    {
      header: t('returnsPage.awaitingTab.returnCost'),
      accessor: (row: TableRowType<TAwaitingParcel>) => (
          <>
            {row.data.directStreamProvider === 'Unitrade' ? (
                <Tooltip
                    action={
                      <div className={styles.actionPrice}>
                        <img
                            src={UIcon}
                            alt="Icon"
                        />
                        {formatSumFromObject(row.data.reexportPrice)}
                      </div>
                    }
                    position="left"
                    text={t('returnsPage.awaitingTab.tooltipText_2')}
                    whiteSpace="pre-wrap"
                    maxWidth={200}
                />
            ) : (
                <Tooltip
                    action={
                      <div className={styles.actionPrice}>
                        <img
                            src={TruckIcon}
                            alt="Icon"
                        />
                        {formatSumWithCurrency(row.data.reexportPrice.amount, variableCurrency)}
                      </div>
                    }
                    position="left"
                    text={`${t('returnsPage.awaitingTab.tooltipText_3')}<br><br>${t('returnsPage.awaitingTab.tooltipText_2')}`}
                    whiteSpace="pre-wrap"
                    maxWidth={200}
                />
            )
            }
          </>
      ),
      noOverflow: true,
      type: TableColumnType.PRIMARY,
      width: '100px'
    },
    {
      header: t('returnsPage.awaitingTab.deliverToLocalCost'),
      accessor: (row: TableRowType<TAwaitingParcel>) => (
          row.data.deliverToLocalPrice ? (
              <div className={styles.actionPrice}>
                {formatSumFromObject(row.data.deliverToLocalPrice)}
              </div>
          ) : (
              <Text color={TextColor.DARK_MUTED} size={TextSize.XS}>—</Text>
          )
      ),
      noOverflow: true,
      type: TableColumnType.PRIMARY,
      width: '100px'
    },
    {
      header: t('returnsPage.awaitingTab.beforeDisposal'),
      accessor: (row: TableRowType<TAwaitingParcel>) => {
        const restDays = getDaysBetweenDates(null, row.data.deadline);
        return (
            <ProgressBar
                column
                label={restDays ? `${restDays} ${t('awaitingTable.days')}` : t('awaitingTable.lastDay')}
                progress={restDays / 14 * 100}
                reverseColors
            />
        );
      },
      width: '100px'
    },
    {
      header: t('returnsPage.awaitingTab.store'),
      accessor: (row: TableRowType<TAwaitingParcel>) => (
          <AvatarWithMarketplace
              id={row.data.seller.id}
              name={row.data.seller.name}
              marketplace={row.data.marketplaceType}
          />
      ),
      alignment: 'center',
      noOverflow: true,
      sortable: true,
      sortableFn: handlerSortByStores
    },
    {
      header: '',
      accessor: (row: TableRowType<TAwaitingParcel>) => (
          row.data.availableForResaleOrders?.length ? (
              <div style={{ marginRight: 15 }}>
                <Button
                    onClick={() => {
                      setParcel(row.data);
                      setParcelView(getPlacingOrderView([row.data], EPlacingOrderViewParcel.RETURN_AWAITING_RESALE, {
                        type: EPlacingOrderViewParcelType.GOOD,
                        variableCurrency
                      }));
                      setProcessingCalledFrom('card');
                      setIsOpenResaleProcessingWindow(true);
                    }}
                    size={ButtonSize.XS}
                    isRounded
                    title={t('returnsPage.awaitingTab.resell')}
                />
              </div>
          ) : null
      ),
      alignment: 'right' as const,
      noOverflow: true,
      fixWidth: true,
      width: '125px'
    }
  ], [currentLanguage, columnsSort]);

  useEffect(() => {
    const columnsSort: string[] = columns.map((item: TableColumn<TAwaitingParcel>) => item.sortable ? 'asc' : '');
    setColumnsSort(columnsSort);
  }, []);

  return (
      <div>
        {sellersNotFound ? (
            <AddSellerPanel
                isFirstSeller
                onSuccess={onUpdateData}
            />
        ) : (
            <>
              {/*<Box pb={5}>*/}
              {/*  <Row gap={6}>*/}
              {/*    <div*/}
              {/*        onClick={(e: React.MouseEvent<HTMLDivElement>) => {*/}
              {/*          e.preventDefault();*/}
              {/*          setIsOpenReturnCostWindow(true);*/}
              {/*        }}*/}
              {/*    >*/}
              {/*      <DocumentLink*/}
              {/*          icon={YuanIcon}*/}
              {/*          text={t('returnsPage.awaitingTab.returnCost')}*/}
              {/*          {...{ url: '' }}*/}
              {/*      />*/}
              {/*    </div>*/}
              {/*  </Row>*/}
              {/*</Box>*/}
              <Box pb={5}>
                <Text
                    color={TextColor.PRIMARY}
                    size={TextSize.S}
                >
                  {t('returnsPage.awaitingTab.info_1')}:
                </Text>
              </Box>
              <Box pb={5}>
                <Text
                    color={TextColor.PRIMARY}
                    size={TextSize.S}
                >
                  <ul className={styles.list}>
                    <li>{t(`returnsPage.awaitingTab.infoPoint_${account!.region === 'TR' ? '2' : '1'}`)}</li>
                    <li>{t('returnsPage.awaitingTab.infoPoint_3')}</li>
                  </ul>
                </Text>
              </Box>
              <Box
                  pb={5}
                  className={cn(!isFilterOpen && styles.hidden)}
              >
                <Column phone={12}>
                  <Row
                      justify="right"
                      gap={5}
                  >
                    <Filters
                        id="returns-awaiting"
                        openFilters={() => setIsFilterOpen(true)}
                        items={[
                          {
                            name: 'trackNumbers',
                            type: FilterTypes.MULTI_SEARCH,
                            placeholder: t('filters.searchByTrackNumber')
                          },
                          {
                            name: 'productConditionType',
                            type: FilterTypes.STATE,
                            placeholder: t('returnsPage.awaitingTab.state')
                          },
                          {
                            name: 'sellerIds',
                            type: FilterTypes.SELLER
                          }
                          // {
                          //   name: "marketplaceType",
                          //   type: FilterTypes.MARKETPLACE,
                          // },
                        ]}
                        onChange={(v, isReady) => {
                          if (isReady) {
                            setIsInitialized(true);
                          }
                          setInnerFilters(v);
                        }}
                        values={innerFilters}
                        asPanel
                    />
                  </Row>
                </Column>
              </Box>
              <TableSelectionPanel
                  isShown={selectedIds.length > 0}
                  items={[
                    {
                      label: t('returnsPage.awaitingTab.selected'),
                      value: selectedIds.length
                    },
                    {
                      label: t('returnsPage.awaitingTab.forTheAmount'),
                      value: formatSumWithCurrency(selectedSumCny, variableCurrency)
                    },
                    {
                      label: t('returnsPage.awaitingTab.delivery'),
                      value: formatSumWithCurrency(selectedReturnCost, variableCurrency)
                    }
                  ]}
                  buttons={[
                    (<Button
                        key="dispose"
                        onClick={() => {
                          setIsOpenDisposalProcessingWindow(true);
                          setProcessingCalledFrom('table');
                        }}
                        size={ButtonSize.S}
                        type={ButtonType.RED_SKELETON}
                        title={t('returnsPage.awaitingTab.dispose') + (selectedDisposalCompensation > 0 ? ` +${formatSumWithCurrency(selectedDisposalCompensation, variableCurrency)}` : '')}
                    />),
                    ((selectedDeliverToLocalCost > 0) && (
                        <Button
                            key="deliverToLocal"
                            onClick={() => {
                              setIsOpenDeliverToLocalProcessingWindow(true);
                              setProcessingCalledFrom('table');
                            }}
                            size={ButtonSize.S}
                            type={ButtonType.GREEN_SKELETON}
                            title={t('returnsPage.awaitingTab.deliverToLocalFor') + ` ${formatSumWithCurrency(selectedDeliverToLocalCost, variableCurrency)}`}
                        />
                    )),
                    (isLastMileResaleFeatureEnabled && hasLastMileWarehouse && (
                        <Tooltip
                            key="resellForLastMile"
                            action={
                              <Button
                                  disabled={!selectedLastMileResaleCost}
                                  onClick={() => {
                                    setIsOpenLastMileProcessingWindow(true);
                                    setProcessingCalledFrom('table');
                                  }}
                                  size={ButtonSize.S}
                                  type={selectedLastMileResaleCost ? ButtonType.GREEN_SKELETON : ButtonType.PRIMARY}
                                  title={selectedLastMileResaleCost ? t('returnsPage.awaitingTab.resellForLastMile') + ` ${formatSumWithCurrency(selectedLastMileResaleCost, variableCurrency)}` : t('returnsPage.awaitingTab.resellLastMile')}
                              />
                            }
                            disabled={Boolean(selectedLastMileResaleCost) || !hasSelectedResaleBlocked}
                            position="top"
                            text={t('returnsPage.awaitingTab.resaleBlockedActionTooltip')}
                        />
                    )),
                    (<Button
                        disabled={!selectedReturnCost}
                        key="returnFor"
                        onClick={() => {
                          setIsOpenReturnProcessingWindow(true);
                          setProcessingCalledFrom('table');
                        }}
                        size={ButtonSize.S}
                        type={ButtonType.PRIMARY}
                        title={selectedReturnCost ? t('returnsPage.awaitingTab.returnFor') + ` ${formatSumWithCurrency(selectedReturnCost, variableCurrency)}` : t('returnsPage.awaitingTab.return')}
                    />)
                  ]}
                  footer={(!selectedResaleCost && !selectedReturnCost) && (
                      <div className={styles.panelFooter}>
                        <Text
                            size={TextSize.M}
                            type={TextType.BLOCK}
                            color={TextColor.ERROR_DARK}
                        >
                          <img
                              alt="Warning"
                              className={styles.warning}
                              src={WarningIcon}
                          />
                          {t(`returnsPage.awaitingTab.reexportBlocked`)}
                        </Text>
                      </div>
                  )}
              >
                <DataTable<TAwaitingParcel>
                    Before={BeforeAwaitingTableComponent}
                    columns={columns}
                    columnsSort={columnsSort}
                    dataRef={dataRef}
                    defaultPageSize={10}
                    filters={tableFilters}
                    getData={getAwaiting}
                    notFound={t('returnsPage.awaitingTab.noParcels')}
                    onSelectionChange={handleSelectionChange}
                    pending={!isInitialized}
                    queryKey="awaitingParcels"
                    selectable
                    selectedIds={selectedIds}
                />
              </TableSelectionPanel>
              <Modal
                  isOpen={isOpenReturnCostWindow}
                  onClickOverlay={() => setIsOpenReturnCostWindow(false)}
                  onClose={() => setIsOpenReturnCostWindow(false)}
                  width={567}
              >
                <ReturnCostModalWindow/>
              </Modal>
              <Modal
                  bodyWithoutIndentations
                  isOpen={isOpenParcelWindow}
                  onClickOverlay={onCloseParcel}
                  onClose={onCloseParcel}
                  width={900}
              >
                <CardParcelModalWindow
                    callFrom="awaitingTab"
                    handlerSetIsOpenDeliverToLocalProcessingWindow={setIsOpenDeliverToLocalProcessingWindow}
                    handlerSetIsOpenDisposalProcessingWindow={setIsOpenDisposalProcessingWindow}
                    handlerSetIsOpenParcelWindow={setIsOpenParcelWindow}
                    handlerSetIsOpenResaleProcessingWindow={setIsOpenResaleProcessingWindow}
                    handlerSetIsOpenReturnProcessingWindow={setIsOpenReturnProcessingWindow}
                    handlerSetProcessingCalledFrom={setProcessingCalledFrom}
                    parcel={parcel!}
                />
              </Modal>
              <Modal
                  isOpen={isOpenDisposalProcessingWindow}
                  onClickOverlay={onCloseDisposalProcessing}
                  onClose={onCloseDisposalProcessing}
                  width={650}
              >
                <DisposalProcessingModalWindow
                    handlerOnCloseDisposalProcessing={onCloseDisposalProcessing}
                    handlerRefreshData={onUpdateData}
                    parcelsGood={processingCalledFrom === 'card' ? parcelView : parcelsGoodDisposalView}
                    selectedSumCny={processingCalledFrom === 'card' ? parcel!.priceCny : selectedSumCny}
                    selectedSumRub={processingCalledFrom === 'card' ? parcel!.priceRub : selectedSumRub}
                />
              </Modal>
              <Modal
                  isOpen={isOpenResaleProcessingWindow}
                  onClickOverlay={onCloseResaleProcessing}
                  onClose={onCloseResaleProcessing}
                  width={650}
              >
                <ResaleProcessingModalWindow
                    errorSendResaleOrder={errorSendResaleOrder}
                    errorSendTopUpBalance={errorSendTopUpBalance}
                    flow="resale"
                    handlerOnCloseResaleProcessing={onCloseResaleProcessing}
                    handlerSubmit={handlerSubmitResale}
                    isErrorSendResaleOrder={isErrorSendResaleOrder}
                    isErrorSendTopUpBalance={isErrorSendTopUpBalance}
                    isLoadingSendResaleOrder={isLoadingSendResaleOrder}
                    isLoadingSendTopUpBalance={isLoadingSendTopUpBalance}
                    parcel={parcel}
                    parcelsAny={processingCalledFrom === 'card' ? undefined : parcelsAnyResaleView}
                    parcelsGood={processingCalledFrom === 'card' ? parcelView : parcelsGoodResaleView}
                    resaleOrderInProcessed={orderInProcessed}
                    selectedResaleCost={processingCalledFrom === 'card' ? parcel!.resalePrice.amount : selectedResaleCost}
                    sumCny={processingCalledFrom === 'card' ? parcel!.priceCny : selectedResaleSumCny}
                    sumRub={processingCalledFrom === 'card' ? parcel!.priceRub : selectedResaleSumRub}
                />
              </Modal>
              <Modal
                  isOpen={isOpenLastMileProcessingWindow}
                  onClickOverlay={onCloseLastMileProcessing}
                  onClose={onCloseLastMileProcessing}
                  width={650}
              >
                <ResaleProcessingModalWindow
                    errorSendResaleOrder={errorSendLastMileResaleOrder}
                    errorSendTopUpBalance={errorSendTopUpBalance}
                    flow="lastMile"
                    handlerOnCloseResaleProcessing={onCloseLastMileProcessing}
                    handlerSubmit={handlerSubmitLastMile}
                    isErrorSendResaleOrder={isErrorSendLastMileResaleOrder}
                    isErrorSendTopUpBalance={isErrorSendTopUpBalance}
                    isLoadingSendResaleOrder={isLoadingSendLastMileResaleOrder}
                    isLoadingSendTopUpBalance={isLoadingSendTopUpBalance}
                    parcelsAny={parcelsAnyLastMileView}
                    parcelsGood={parcelsGoodLastMileView}
                    resaleOrderInProcessed={orderInProcessed}
                    selectedResaleCost={selectedLastMileResaleCost}
                    sumCny={selectedLastMileSumCny}
                    sumRub={selectedLastMileSumRub}
                />
              </Modal>
              <Modal
                  isOpen={isOpenReturnProcessingWindow}
                  onClickOverlay={onCloseReturnProcessing}
                  onClose={onCloseReturnProcessing}
                  width={650}
              >
                <PlacingOrderModalWindow
                    availableCountries={['CN', 'HK']}
                    costOfService={processingCalledFrom === 'card' ? parcel!.reexportPrice.amount : selectedReturnCost}
                    errorSendPlacingOrder={errorSendReturnOrder}
                    errorSendTopUpBalance={errorSendTopUpBalance}
                    handlerOnClosePlacingOrderProcessing={onCloseReturnProcessing}
                    handlerResetSendOrder={resetSendReturnOrder}
                    handlerSubmit={handlerSubmitReturn}
                    isErrorSendPlacingOrder={isErrorSendReturnOrder}
                    isErrorSendTopUpBalance={isErrorSendTopUpBalance}
                    isLoadingSendPlacingOrder={isLoadingSendReturnOrder}
                    isLoadingSendTopUpBalance={isLoadingSendTopUpBalance}
                    parcelsAny={processingCalledFrom === 'card' ? undefined : parcelsAnyReturnView}
                    parcelsGood={processingCalledFrom === 'card' ? parcelView : parcelsGoodReturnView}
                    placingOrderInProcessed={orderInProcessed}
                    placingOrderType={EPlacingOrder.RETURN_AWAITING}
                />
              </Modal>
              <Modal
                  isOpen={isOpenDeliverToLocalProcessingWindow}
                  onClickOverlay={onCloseDeliverToLocalProcessing}
                  onClose={onCloseDeliverToLocalProcessing}
                  width={650}
              >
                <PlacingOrderModalWindow
                    availableCountries={['RU']}
                    costOfService={processingCalledFrom === 'card' ? parcel!.deliverToLocalPrice!.amount : selectedDeliverToLocalCost}
                    errorSendPlacingOrder={errorSendDeliverToLocalOrder}
                    errorSendTopUpBalance={errorSendTopUpBalance}
                    handlerOnClosePlacingOrderProcessing={onCloseDeliverToLocalProcessing}
                    handlerResetSendOrder={resetSendDeliverToLocalOrder}
                    handlerSubmit={handlerSubmitDeliverToLocal}
                    isErrorSendPlacingOrder={isErrorSendDeliverToLocalOrder}
                    isErrorSendTopUpBalance={isErrorSendTopUpBalance}
                    isLoadingSendPlacingOrder={isLoadingSendDeliverToLocalOrder}
                    isLoadingSendTopUpBalance={isLoadingSendTopUpBalance}
                    parcelsGood={processingCalledFrom === 'card' ? parcelView : parcelsGoodDeliverToLocalView}
                    placingOrderInProcessed={orderInProcessed}
                    placingOrderType={EPlacingOrder.RETURN_AWAITING}
                />
              </Modal>
              <Modal
                  isOpen={isOpenPaymentWindow}
                  onClickOverlay={onClosePaymentReturn}
                  onClose={onClosePaymentReturn}
                  width={560}
              >
                <PaymentModalWindow
                    dataSendTopUpBalance={dataSendTopUpBalance!}
                    errorGetPaymentLink={errorGetPaymentLink}
                    handlerOnClickPaymentLink={onClickPaymentLink}
                    isErrorGetPaymentLink={isErrorGetPaymentLink}
                    isLoadingGetPaymentLink={isLoadingGetPaymentLink}
                    isLoadingSendTopUpBalance={isLoadingSendTopUpBalance}
                    mutateSendTopUpBalance={mutateSendTopUpBalance}
                    paymentError={paymentError}
                    paymentInProcessed={paymentInProcessed}
                    selectedSum={
                      processingPaymentType === 'return'
                          ? processingCalledFrom === 'card' ? parcel!.reexportPrice.amount : selectedReturnCost
                          : processingPaymentType === 'lastMile'
                              ? selectedLastMileResaleCost
                              : processingPaymentType === 'deliverToLocal'
                                  ? processingCalledFrom === 'card' ? parcel!.deliverToLocalPrice!.amount : selectedDeliverToLocalCost
                                  : processingCalledFrom === 'card' ? parcel!.resalePrice.amount : selectedResaleCost
                    }
                    subTitle={
                      processingPaymentType === 'return'
                          ? t('paymentModalWindow.subTitle_1')
                          : processingPaymentType === 'deliverToLocal'
                              ? t('paymentModalWindow.subTitle_3')
                              : t('paymentModalWindow.subTitle_2')
                    }
                />
              </Modal>
              <Modal
                  isOpen={isOpenPaymentCompletedWindow}
                  onClickOverlay={() => setIsOpenPaymentCompletedWindow(false)}
                  onClose={() => setIsOpenPaymentCompletedWindow(false)}
                  width={560}
              >
                <PaymentCompletedModalWindow
                    handlerSetIsOpenPaymentCompletedWindow={setIsOpenPaymentCompletedWindow}
                    title={
                      processingPaymentType === 'return'
                          ? t('paymentCompletedModalWindow.info_1')
                          : processingPaymentType === 'deliverToLocal'
                              ? t('paymentCompletedModalWindow.info_3')
                              : t('paymentCompletedModalWindow.info_2')
                    }
                />
              </Modal>
            </>
        )}
      </div>
  );
};

export default AwaitingTab;
